export function getText(value) {
  return (
    value ||
    'I agree that the practice may share my contact information with trusted partners so they can send me relevant offers and promotions'
  )
}
